import { resolveImagePath } from '@/utils/imageResolver';

export function About() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-600 mb-8">About Us</h2>
          <div className="w-24 h-px bg-blue-600 mx-auto"></div>
        </div>

        {/* Main About Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-start mb-16">
          {/* Left Column - Image */}
          <div className="order-2 lg:order-1">
            <img 
              src={resolveImagePath('/images/about-airport-aerial.jpeg')}
              alt="Aerial view of Goodspeed Airport along the Connecticut River"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>

          {/* Right Column - Content */}
          <div className="order-1 lg:order-2">
            <h3 className="text-xl font-bold text-gray-800 mb-6">
              Goodspeed Airport and Seaplane Base
            </h3>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                Set on 57 acres along the Connecticut River, Goodspeed Airport is a little 
                haven for aviation in eastern Connecticut. With a 2,100' asphalt runway and 
                4,500' water runway, along with several banks of hangars, Goodspeed (42B) has 
                recently come under new ownership in November 2020 and, with the support of the 
                Recreational Aviation Foundation, is looking to revitalize and renew the 
                aviation community at this picturesque airport in the Northeast.
              </p>
              <p>
                Our location along the Connecticut River by the lovely East Haddam village makes 
                for a great destination airport for those seeking beautiful sunsets over the 
                bridge, natural wonders of the Connecticut river, a show at the Goodspeed Opera 
                house, riverboat rides, or good food at one of the local restaurants just steps away.
              </p>
              <p className="font-semibold text-gray-800">
                Most importantly, it's a fun place to fly!
              </p>
            </div>
          </div>
        </div>

        {/* History Section */}
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Column - History Content */}
          <div>
            <h3 className="text-xl font-bold text-gray-800 mb-6">
              History of the airport
            </h3>
            <div className="text-gray-600 leading-relaxed">
              <p>Under construction</p>
            </div>
          </div>

          {/* Right Column - Image */}
          <div>
            <img 
              src={resolveImagePath('/images/about-runway-view.jpeg')}
              alt="Runway view at Goodspeed Airport"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}